import React, { useContext } from "react";
import "yet-another-react-lightbox/styles.css";
import GlobalContext, { GlobalContextType } from "../contexts/global-provider";
// import useBrokenImageTracker from "../utils/hooks/use-broken-image-tracker";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  if (process.env.GATSBY_WEBSITE === "Sportreizen") {
    require("./../scss/main.sportreizen.scss");
  } else {
    require("./../scss/main.voetbalreizen.scss");
  }

  // useBrokenImageTracker();
  const { qsmActive, isBookingPage } = useContext<GlobalContextType>(GlobalContext);

  return <div className={`page-components${qsmActive ? " qsm-active" : ""}${isBookingPage ? " page-components--booking" : ""}`}>{children}</div>;
};

export default Layout;
